<template>
  <div class="sub-account"
       ref="subAccount"
       v-if="issuingCountry==='CHN'">
    <!-- <div> -->
    <bCardHeader :param="param"
                 class="card-header"></bCardHeader>
    <el-row :gutter="30"
            class="m-0">
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              class="p-0">

        <div v-if="detailsLength != 0"
             class="card-base card-shadow--small sub-account-details"
             style="">
          <div v-for="(item, key) in detailsArr"
               :key="key">
            <h4><i class="el-icon-document"></i> {{$t('subAccount.detailsTitle')}}</h4>
            <p>{{$t('subAccount.detailsBankName')}}: {{item.name}}</p>
            <p>{{$t('subAccount.detailsBankCardNumber')}}: {{item.account}}</p>
            <p>{{$t('subAccount.detailsPayeeName')}}: {{item.payeeName}}</p>
            <p>{{$t('subAccount.detailsSwiftCode')}}: {{item.swiftCode}}</p>
            <p>{{$t('subAccount.detailsBankAddress')}}: {{item.address}}</p>
            <p v-if="!isEn">{{$t('subAccount.detailsAliasAddress')}}: {{item.aliasAddress || ''}}</p>
          </div>
        </div>

        <div v-if="subApply"
             class="card-base card-shadow--small sub-account-form">
          <h1 class="h1-title">{{$t('subAccount.children_account')}}</h1>
          <el-form ref="form"
                   :model="form"
                   :rules="rules"
                   label-position="top">
            <!-- <el-form-item :label="$t('subAccount.number')" prop="number">
                <el-input v-model="form.number" disabled>
                </el-input>
              </el-form-item> -->
            <el-form-item :label="$t('subAccount.customer')"
                          prop="customer">
              <el-input v-model="userName"
                        disabled>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('subAccount.amount')"
                          prop="amount">
              <el-input v-model="form.amount"
                        type="number"
                        step="0.01"
                        test_id="Estimated_deposit_amount">
                <template slot="prepend">HKD</template>
                <div slot="prefix"
                     class="money-icon">$</div>
              </el-input>
            </el-form-item>
            <el-form-item prop="checked">
              <el-checkbox v-model="checked"
                           test_id="check_box">{{$t('applyTradeAccount.checkedConfirm')}}</el-checkbox>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button test_id="button_submit"
                         type="primary"
                         class="el-button-sub"
                         @click="submitFn('form')">{{$t('common.submit')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12">
        <TreeList :params="parentList"
                  :height="height"
                  :text="$t('subAccount.noSub')"></TreeList>
      </el-col>
    </el-row>
    <!-- </div> -->
    <!-- 表单需要提交参数预览弹窗 -->
    <bPreviewDialog :dialogVisible.sync="IsPreviewShow"
                    :closeModal="closeModal"
                    :loading.sync="loadingSub"
                    :params="form"
                    :handle="createsubAccount"
                    :currency="currency"></bPreviewDialog>
    <!-- 获取申请码弹窗 -->
  </div>
  <div v-else
       class="sub-account-container">
    <img src="@/assets/images/icon_hint@2x.png"
         alt="">
    {{$t('subAccount.notCHN')}}
  </div>
</template>

<script>
import complete from '../fund-transfer/info-dialog.vue'
import TreeList from './three-list'
import subAccountRequest from '@/api/v2/subAccount.js'
import { mapGetters } from 'vuex'
export default {
  data () {
    var validateAmount = (rule, value, callback) => {
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (value === '') {
        return callback(new Error(this.$t('errorTips.pls_input')))
      } else if (this.form.amount < 0) {
        return callback(new Error(this.$t('errorTips.min')))
      } else if (!reg.test(value)) {
        return callback(new Error(this.$t('errorTips.correctAmount')))
      } else {
        return callback()
      }
    }
    // var validateName = (rule, value, callback) => {
    //   var reg = /^[A-Za-z]+$/
    //   if (value === '') {
    //     return callback(new Error(this.$t('errorTips.pls_input')))
    //   } else if (!reg.test(value)) {
    //     return callback(new Error(this.$t('errorTips.pls_input_name_pinyin')))
    //   } else {
    //     return callback()
    //   }
    // }
    var checkedVal = (rule, value, callback) => {
      console.log(rule, value)
      var f = rule.field
      if (!this[f]) {
        return callback(new Error(this.$t('applyTradeAccount.checked')))
      }
      callback()
    }
    return {
      checked: false,
      text: 'noSub',
      form: {
        // number: this.$getProfile().custom.accountNumber,
        customer: '',
        amount: ''
      },
      height: 550,
      parentList: [],
      orderId: '',
      currency: 'HKD',
      closeModal: false,
      loadingSub: false,
      IsPreviewShow: false, // 是否打开预览
      showClose: false, // 申请码关闭小图标
      contiune: true, // 申请码继续按钮
      IsCodeShow: false, // 是否打开申请码弹窗
      componentDialog: complete, // 申请码弹窗内容
      rules: {
        checked: [
          {
            validator: checkedVal
          }
        ],
        // customer: [
        //   {
        //     required: true,
        //     message: this.$t('errorTips.pls_input'),
        //     trigger: 'change'
        //   },
        //   {
        //     required: true,
        //     validator: validateName,
        //     trigger: 'blur'
        //   }
        // ],
        amount: [
          {
            required: true,
            validator: validateAmount,
            trigger: 'blur'
          }
        ]
      },
      param: {
        title: 'children_account',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'children_account'
          }
        ]
      },
      detailsArr: [],
      detailsLength: '',
      subApply: false,
      issuingCountry: 'CHN'
    }
  },
  components: {
    TreeList
  },
  created () {
    this.issuingCountry = this.getClientProfile.userInfo.issuingCountry
  },
  mounted () {
    this.subAccountDetailsFn()
    this.getBankSubAccountList()
  },
  computed: {
    ...mapGetters(['getAccountInfo', 'getClientProfile']),
    userName () {
      let firstName = this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.firstName : ''
      let lastName = this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.lastName : ''
      return lastName + ' ' + firstName
    },
    isEn() {
      return sessionStorage.getItem('language') === 'en'
    }
  },
  methods: {
    subAccountDetailsFn () {
      // this.$api
      //   .getsubAccount({
      //     limit: '',
      //     searchParams: {
      //       accountNumber: this.$getProfile().custom.accountNumber,
      //       isLock: true
      //     },
      //     sortKey: 'createdTime',
      //     sortVal: '-1'
      //   })
      //   .then(result => {
      //     console.log('****************** result ', result)
      //     var tempArr = result.data.rows
      //     if ((tempArr.length === 0) || (tempArr[0].status === 'failure') || (tempArr[0].bankKey === 'BOC' && tempArr[0].status === 'completed')) {
      //       this.subApply = true
      //     }
      //     tempArr.forEach(item => {
      //       if (item.bankKey !== 'BOC' && item.status === 'completed') {
      //         this.subApply = false
      //       }
      //     })
      //     this.detailsArr = [] // 清空数组
      //     for (var i = 0; i < tempArr.length; i++) {
      //       if (tempArr[i].status === 'completed') {
      //         this.detailsArr.push(tempArr[i])
      //       }
      //     }
      //     this.detailsLength = this.detailsArr.length
      //   })

      subAccountRequest.getsubAccount().then(res => {
        // this.initTreeList(res.data)
        let data = res.data
        if (data.isCanApplication) {
          // 判断是否可以申请子账户
          this.subApply = true
        }
        this.detailsArr = data.bankSubList ? data.bankSubList : []
        this.detailsLength = this.detailsArr.length
      })
    },
    getBankSubAccountList () {
      // this.$api
      //   .getsubAccount({
      //     limit: '3',
      //     searchParams: {
      //       accountNumber: this.$getProfile().custom.accountNumber,
      //       isLock: true
      //     },
      //     sortKey: 'createdTime',
      //     sortVal: '-1'
      //   })
      //   .then(result => {
      //     this.initTreeList(result.data.rows)
      //   })
      subAccountRequest.getsubAccountRecord().then(res => {
        this.initTreeList(res.data)
      })
    },
    createsubAccount () {
      this.loadingSub = true
      let formData = {}
      this.closeModal = false
      formData.accountId = this.getAccountInfo._id
      formData.accountNumber = this.form.number
      formData.fullName = this.userName
      formData.currency = 'HKD'
      formData.applicationAmount = this.form.amount
      formData.status = 'submitted'
      formData.checkStatus = 'submitted,verified'
      formData.type = 'sub'
      formData.isLock = true
      formData.accountMaster = this.$t('subAccount.accountMaster')
      formData.applySource = 'clientPortal'
      // 这里需要向系统获取当前的选择的语言
      // this.$api
      //   .createsubAccount(formData)
      //   .then(result => {
      //     this.orderId = result.data.orderId
      //     this.openMessage('success', this.$t('subAccount.success'))
      //     this.$refs['form'].resetFields()
      //     this.IsPreviewShow = false
      //     this.closeModal = false
      //     // this.IsCodeShow = true //提交之后返回
      //     this.loadingSub = false
      //     this.subAccountDetailsFn()
      //     this.getBankSubAccountList()
      //   })
      //   .catch(error => {
      //     console.log(error)
      //     this.closeModal = true
      //     this.loadingSub = false
      //   })
      //   .catch(error => {
      //     console.log(error)
      //     this.closeModal = true
      //     this.loadingSub = false
      //   })
      let params = {
        advanceAmount: this.form.amount,
        currency: 'HKD',
        submitSource: 'CP_WEB'
      }
      subAccountRequest.commitSubAccout(params).then(res => {
        this.closeModal = false
        this.orderId = res.data.orderId
        this.openMessage('success', this.$t('subAccount.success'))
        this.$refs['form'].resetFields()
        this.IsPreviewShow = false
        this.closeModal = false
        this.loadingSub = false
        this.getBankSubAccountList()
        this.subAccountDetailsFn()
      })
        .catch(e => {
          this.closeModal = true
          this.loadingSub = false
        })
    },
    initTreeList (data) {
      this.parentList = []
      data.forEach(element => {
        let item = {}
        item.updatedTime = element.createdDate
        item.status = element.status.toLowerCase()
        item.accountNumber = element.accountNumber
        item.childList = {
          fullName: element.fullName,
          applicationAmount:
            element.currency +
            ' ' +
            this.Util.formatCurrency(element.advanceAmount),
          fundBankType: element.actionType ? (element.actionType === 'CANCEL' ? this.$t('common.accountClose') : this.$t('common.accountOpen')) : '',
          accountName: element.subBankName
        }
        this.parentList.push(item)
        console.log(this.parentList)
      })
    },
    refresh () {
      this.$refs['form'].resetFields()
    },
    submitFn (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.form.customer = this.userName
          this.IsPreviewShow = true
          // this.$api
          //   .checkSubAccountOrders({
          //     accountNumber: this.$getProfile().custom.accountNumber,
          //     checkStatus: 'submitted,verified'
          //   })
          //   .then(result => {
          //     let submittedOrder = result.data.count ? result.data.count : 0
          //     if (submittedOrder > 0) {
          //       return this.openMessage(
          //         'warning',
          //         this.$t('errorTips.unprocessedData')
          //       )
          //     }
          //     this.form.customer = this.userName
          //     this.IsPreviewShow = true
          //   })
          //   .catch(error => {
          //     console.log(error)
          //   })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.sub-account {
  height: min-content;
  .page-header {
    margin-bottom: 20px;
  }
  .sub-account-details {
    height: 640px;
    padding: 0px 30px;
    margin-bottom: 20px;
    overflow: auto;
    h4 {
      border-bottom: 2px solid #ccc;
      padding-bottom: 10px;
    }
  }
  .sub-account-form {
    height: 640px;
    padding: 0px 30px;
    margin-bottom: 20px;
    .money-icon {
      height: 40px;
      line-height: 40px;
      padding: 0 10px;
      color: #24282d;
      font-weight: bold;
    }

    .el-input__inner {
      font-family: Muli-Regular;
      font-size: 14px;
      color: #24282d;
      letter-spacing: 0;
      // font-weight: 600;
    }

    .el-input-group__prepend {
      background: #f3f4f6;
      font-weight: bold;
      color: #24282d;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .readonly-input .el-input.is-disabled .el-input__inner {
      background: #e2e2e2;
      color: #24282d;
    }

    .el-button {
      margin-top: 20px;
      width: 50%;
      color: #192b57;
      font-weight: bold;
      height: 56px;
      border-color: #ffe080;
      background-color: #fecd33;
      max-width: 250px;
    }

    .el-button--primary span {
      font-family: Muli-Bold;
      font-size: 14px;
      color: #193060;
      letter-spacing: 0.17px;
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
      border-color: #fecd33;
      background-color: #fecd33;
      color: #192b57;
    }

    .h1-title {
      border-bottom: 4px solid #e2e2e2;
      margin: 0 0 20px;
      padding: 20px 0;
      font-weight: bold;
      color: #182a54;
      font-size: 18px;
    }
    .el-checkbox__inner::after {
      height: 12px;
      left: 8px;
      top: 3px;
      width: 3px;
    }
    .el-checkbox__inner {
      width: 22px;
      height: 22px;
    }
  }
  .el-checkbox__label{
    white-space: normal;
    word-break: break-word;
  }
}
.sub-account-container {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #192b57;
  line-height: 20px;
  background-color: #fff;
  margin: 20px 40px 30px;
  border-radius: 5px;
  box-shadow: 0px 3px 7px 0px rgba(179, 179, 179, 0.5);
  img {
    padding-top: 259px;
    width: 60px;
    margin-bottom: 37px;
  }
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
  .m-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .p-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .m15 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
</style>
